import React from 'react';
import ReactDOM from 'react-dom/client';

// Hoja de estilos global
import './index.css';

// Componente principal
import App from './App';

// Web Vitals
import reportWebVitals from './reportWebVitals';

// // Tipografía global SonnyVol2
import "./styles/fonts.css";

// Crear raíz de React
const root = ReactDOM.createRoot(
  document.getElementById('root')
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Reportar Web Vitals
reportWebVitals();